<template>
    <section class="testimonials">
      <div class="container">
        <h2 class="section-title">What Our Admins Say</h2>
        <div class="testimonial-grid">
          <div class="testimonial-card" v-for="testimonial in testimonials" :key="testimonial.id">
            <div class="testimonial-rating">
              <i v-for="star in 5" :key="star" :class="getStarClass(star, testimonial.rating)"></i>
            </div>
            <p class="testimonial-text">"{{ testimonial.text }}"</p>
            <div class="testimonial-author">
              <img :src="testimonial.author.image" :alt="testimonial.author.name">
              <div>
                <h4>{{ testimonial.author.name }}</h4>
                <p>{{ testimonial.author.title }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'TestimonialsSection',
    data() {
      return {
        testimonials: [
          {
            id: 1,
            text: "Need the help for developments for the web site. please report the issues using under the purple color boutton",
            rating: 5,
            author: {
              name: "Shehan Rajapaksha",
              title: "Owner And Developer",
              image: "@/assets/images/avatar.jpg"
            }
          }
        ]
      }
    },
    methods: {
      getStarClass(star, rating) {
        if (star <= Math.floor(rating)) return 'fas fa-star'
        if (star === Math.ceil(rating) && rating % 1 > 0) return 'fas fa-star-half-alt'
        return 'far fa-star'
      }
    }
  }
  </script>
  
  <style scoped>
  .testimonials {
    padding: 60px 0;
  }
  
  .testimonial-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }
  
  .testimonial-card {
    background-color: var(--white);
    border-radius: var(--border-radius);
    padding: 30px;
    box-shadow: var(--box-shadow);
  }
  
  .testimonial-rating {
    color: #ffc107;
    margin-bottom: 15px;
  }
  
  .testimonial-text {
    font-style: italic;
    margin-bottom: 20px;
    color: var(--text-color);
  }
  
  .testimonial-author {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  
  .testimonial-author img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
  }
  
  .testimonial-author h4 {
    font-size: 16px;
    font-weight: 600;
  }
  
  .testimonial-author p {
    font-size: 14px;
    color: var(--text-light);
  }
  
  @media (max-width: 992px) {
    .testimonial-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  
  @media (max-width: 768px) {
    .testimonial-grid {
      grid-template-columns: 1fr;
    }
  }
  </style>